import ApiClient from "../../ApiClient";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const GOOGLE_REDIRECT_URI =
  process.env.REACT_APP_GOOGLE_REDIRECT_URI ||
  `${window.location.origin}/google/callback`;
// The callback page always loads on this fixed origin, regardless of which
// tenant subdomain opened the popup, so message listeners must check the
// event against this origin rather than their own window.location.origin.
export const GOOGLE_REDIRECT_ORIGIN = new URL(GOOGLE_REDIRECT_URI).origin;

// gmail.modify is a superset of gmail.readonly (covers reading too) and adds
// the trash/delete-message capability. The token itself never reaches the
// browser — it's exchanged and stored server-side via connectGmail() below.
const GMAIL_SCOPE =
  "openid email profile https://www.googleapis.com/auth/gmail.send https://www.googleapis.com/auth/gmail.modify";

export const getGmailOAuthUrl = () => {
  // `flow: "gmail"` tags this OAuth round-trip so the shared GoogleCallback.js
  // page knows to use the server-side (BFF) exchange instead of returning a
  // raw token (matches the `flow: "meet"` pattern GoogleAuthSection.js uses).
  const state = JSON.stringify({
    origin: window.location.origin,
    flow: "gmail",
  });

  return (
    `https://accounts.google.com/o/oauth2/v2/auth` +
    `?response_type=code` +
    `&client_id=${GOOGLE_CLIENT_ID}` +
    `&redirect_uri=${encodeURIComponent(GOOGLE_REDIRECT_URI)}` +
    `&scope=${encodeURIComponent(GMAIL_SCOPE)}` +
    `&access_type=offline` +
    `&prompt=consent` +
    `&state=${encodeURIComponent(state)}`
  );
};

export async function connectGmail(code) {
  const resp = await ApiClient.post("/Email/oauth/gmail/connect", { code });
  return resp.data.data;
}

export async function getGmailConnectionStatus() {
  const resp = await ApiClient.get("/Email/oauth/gmail/status");
  return resp.data.data;
}

export async function disconnectGmail() {
  const resp = await ApiClient.delete("/Email/oauth/gmail/disconnect");
  return resp.data.data;
}
